import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=15143c44&scoped=true&"
import script from "./sidebar.ts?vue&type=script&lang=ts&"
export * from "./sidebar.ts?vue&type=script&lang=ts&"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=15143c44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15143c44",
  null
  
)

export default component.exports